import { useEffect, useState } from 'react';
import clienteAxios from '../../../configAxios/configAxios';


const useConcesionarios = (servicios, zona, region) => {
    const [concesionarios, setConcesionarios] = useState([])
    const [isLoading, setIsloading] = useState(false);
    const [error, setError] = useState(false);



    const fetchConcesionariosFiltro = async () => {

        let zonaF = zona === undefined ? "" : zona;
        let regionF = region === undefined ? "" : region.toString();
        let venta = "";
        let repuestos = "";
        let servicio = "";
        //eslint-disable-next-line
        if (servicios && servicios.length > 0) {
            servicios.map(nombreServicio => {
                if (nombreServicio === "venta") {
                    venta = "venta";
                }
                else if (nombreServicio === "repuestos") {
                    repuestos = "repuestos";
                }
                else if (nombreServicio === "servicio") {
                    servicio = "servicio";
                }
            });
        }
        try {
            let data = { venta, repuestos, servicio, zona: zonaF, region: regionF };
            setIsloading(true)
            let response = await clienteAxios.post('filtrarOficinas', data);

            if (response.status === 200) {
                let datos = response.data.data;
                let concesionarios = Object.keys(datos).map(x => datos[x]);
                setConcesionarios(concesionarios);
                setIsloading(false)
                return;
            }
            setError(true);
            setIsloading(false)
        } catch (error) {
            setError(true);
            setIsloading(false);
        }

    }

    useEffect(() => {
        fetchConcesionariosFiltro();
        //eslint-disable-next-line
    }, [servicios, zona, region])


    return [concesionarios, isLoading, error];
}

export const useZonas = () => {
    const [zonas, setZonas] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(false);

    const fetchZonas = async () => {

        try {
            let response = await clienteAxios.get('ListarUbigeoPorZona');

            setIsLoading(false);

            if (response.status === 200) {
                let data = response.data.data;
                setZonas(data);
                return;
            }

            setError(true);
        } catch (error) {
            setIsLoading(false);
            setError(true);
        }
    }

    useEffect(() => {
        fetchZonas();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return [zonas, isLoading, error];
}

export const useRegiones = (zona) => {
    const [regiones, setRegiones] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(false);

    const fetchRegiones = async () => {
        try {
            setIsLoading(true);
            let response = await clienteAxios.get(`BuscarRegionPorZona/${zona}`);

            setIsLoading(false);
            if (response.status === 200) {
                let data = response.data.data;
                setRegiones(data);
                return;
            }

            setError(true);

        } catch (error) {
            setError(true);
        }
    }

    useEffect(() => {
        if (zona !== undefined) {
            fetchRegiones()
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [zona])

    return [regiones, isLoading, error];
}

export const useOficinaConcesionario = (idOficina, servicio) =>{
    const [oficina,setOficina] = useState(undefined);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(false);

    useEffect(() => {
        const AC = new AbortController();
        const fetchOficina = async () =>{
            try {
                let response = await clienteAxios.get(`Servicio/oficina/${idOficina}/${servicio}`);
                
                if(response.status === 200){
                    let data = response.data.data;
                    if(data && data.length > 0){
                        setOficina(data[0]);
                        setIsLoading(false);
                        return
                    }
                }
                setIsLoading(false);
                setError(true);
            } catch (error) {
                setIsLoading(false);
                setError(true);
            }
        }
        if(idOficina && servicio){
            fetchOficina();
        }

        return () => AC.abort();
    },[idOficina,servicio]);

    return {oficina, isLoading, error};
}

export default useConcesionarios;